import { render } from "./WorkAfterUkStep.vue?vue&type=template&id=d6be5b9a"
import script from "./WorkAfterUkStep.vue?vue&type=script&lang=js"
export * from "./WorkAfterUkStep.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__